import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar26Colors = {
  background?: string;
  accessories?: string;
  skin?: string;
  hair?: string;
};

export const Avatar26 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar26Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    accessories: colors.accessories ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar26">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="accessories"
            d="M165.688 167.999C111.552 183.688 20.9 192.02 10.812 170.152c-13.02-28.232 64.24-80.707 138.552-96.133 74.312-15.427 125.357-8.254 130.219 16.141 4.512 22.623-56.948 61.34-113.903 77.839h.008Z"
            fill={c.accessories}
          />
          <Path
            id="skin"
            d="M219.814 157.855c.445-7.745-1.731-10.581-1.731-24.768.683-46.232-18.398-62.183-55.478-62.183-32.902 0-59.807 9.16-59.807 52.15 0 2.24-.374 1.406-.175 3.717-6.347 0-11.828 13.83-9.048 22.441 6.514 20.185 21.988 20.471 22.298 20.296 2.534 5.942-2.979 44.174-4.663 50.99-2.709 11.009-14.155 18.595-14.155 18.595s76.679 57.361 83.979 53.977c7.308-3.376 10.096-43.07-9.548-48.043-3.202-.81-.31-21.757.357-33.529 9.04-1.359 18.366 4.917 24.633-1.343 6.522-13.655 22.647-40.321 23.338-52.292v-.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector"
            opacity={0.75}
            d="M170.231 230.116c.754-6.918 2.653-19.104 2.24-19.191-22.282-4.981-35.516-16.15-40.822-21.067 0 .453 11.351 34.754 38.582 40.258Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_2"
            opacity={0.75}
            d="M166.656 175.339c.699.85 10.224 16.101 22.147 16.459 10.152.309 14.314-11.344 14.608-11.932 0 0-4.091-5.465-7.213-5.56-3.121-.095-5.425 1.581-5.425 1.581s-2.653-2.217-5.966-2.32c-3.312-.103-6.41 1.748-9.548 2.137-3.177.397-8.595-.373-8.595-.373l-.008.008Zm4.107 2.629c-.079-.064 0-.175.095-.127 3.662 1.914 10.144 3.511 20.36 3.821 5.258.159 8.738.214 11.701-.715-2.963 1.199-7.022 4.734-12.265 4.575-10.232-.31-16.316-4.869-19.883-7.562l-.008.008Z"
            fill="#2E2017"
          />
          <Path
            id="accessories_2"
            d="M66.472 105.323s-3.043-38.4 2.39-46.216c5.434-7.808 26.485-23.425 52.627-31.242 26.142-7.808 50.934-6.108 56.367-2.033 5.434 4.075 28.065 40.29 28.065 40.29s-39.075 1.572-65.185 9.516C90 91.064 66.464 105.315 66.464 105.315l.008.008Z"
            fill={c.accessories}
          />
          <Path
            id="Vector_3"
            d="M139.425 63.7c-43.967 14.203-64.072 27.644-73.247 37.271.159 2.693.294 4.353.294 4.353s23.536-14.25 74.272-29.677c26.11-7.943 65.185-9.516 65.185-9.516s-1.883-3.01-4.695-7.396c-12.916-3.614-32.727-4.424-61.809 4.973V63.7Z"
            fill="#CFCFCF"
          />
          <Path
            id="Vector_4"
            opacity={0.75}
            d="M183.551 162.318c-.603 2.351 2.304 3.908 12.273 3.511 8.214-.325 10.859-4.782 9.246-5.409-1.612-.628-3.773 2.176-9.119 2.176-7.8 0-11.804-2.629-12.408-.278h.008Z"
            fill="#2E2017"
          />
          <Path
            id="accessories_3"
            d="M279.59 88.586c-4.837-24.808-55.621-32.1-129.559-16.411C76.092 87.863-.778 141.228 12.178 169.936c3.376 7.475 15.808 11.479 32.863 12.893 2.645-28.486 52.936-71.31 101.51-84.854 53.945-15.037 91.002-8.046 94.529 15.737 1.136 7.641-3.487 17.166-11.717 27.024 30.758-17.508 53.008-37.947 50.235-52.15h-.008Z"
            fill={c.accessories}
          />
          <Path
            id="hair"
            d="M221.363 93.416c-3.614-1.207-7.681-2.089-12.162-2.645 6.141 9.747 9.151 23.513 8.873 42.315 0 14.196 2.177 17.023 1.732 24.768-.691 11.963-16.816 38.63-23.338 52.293-6.26 6.26-15.593-.016-24.633 1.342-.667 11.781-3.567 32.72-.358 33.53 5.259 1.327 8.905 5.148 11.296 10.089l27.016 6.482s7.435-6.443 9.723-12.71c2.288-6.268 2.836-8.889 1.645-18.604 9.714 12.027-4.457 31.79-4.457 31.79s8.119-5.775 11.185-16.252c3.066-10.478-6.8-21.416-4.751-27.954 2.058-6.545 12.933-20.089 13.854-45.35.048-1.247 3.686 19.692-5.306 35.985 15.704-12.599 13.782-101.464-10.319-115.087v.008Z"
            fill={c.hair}
          />
          <Path
            id="Vector_5"
            d="M137.154 121.815s12.765-4.012 22.687-3.94c11.661.087 19.859 7.888 22.107 3.9.715-1.271.23-7.944-21.035-10.136-9.516-.977-15.109 3.487-23.759 10.176Z"
            fill="#000"
          />
          <Path
            id="Vector_6"
            d="M177.873 137.217c-2.875-4.917-7.642-9.453-13.631-10.549-2.701-.318-5.426-.016-7.991.985-2.097.802-3.718 2.129-5.267 3.463-2.105 1.462-4.909.906-7.443.604 2.391 1.676 5.942 3.018 8.857 1.581a27.648 27.648 0 0 1 2.026-1.184c-.016.215-.04.421-.04.636 0 3.908 3.281 7.077 7.324 7.077 4.043 0 7.324-3.169 7.324-7.077 0-.318-.032-.636-.072-.946 2.868 1.319 5.76 3.265 8.929 5.41h-.016Z"
            fill="#000"
          />
          <Path
            id="Vector_7"
            d="M217.185 114.786c-13.941-.421-21.98 7.316-20.479 10.183.93 1.78 3.774 1.851 5.871-.159 5.751-4.933 9.19-3.288 15.22-3.368-.104-2.105-.414-4.909-.612-6.656Z"
            fill="#000"
          />
          <Path
            id="Vector_8"
            d="M223.222 133.65c-1.556-1.327-3.169-2.661-5.266-3.464-2.566-.993-5.298-1.302-7.991-.985-5.99 1.097-10.756 5.632-13.632 10.549 1.629-1.096 3.178-2.144 4.695-3.09.278 3.44 3.249 6.149 6.879 6.149 3.813 0 6.903-2.987 6.903-6.673a6.391 6.391 0 0 0-1.001-3.416c2.471.278 5.092 1.232 8.007 3.114 2.916 1.438 6.459.096 8.858-1.581-2.534.294-5.339.85-7.444-.603h-.008Z"
            fill="#000"
          />
          <G id="Group_2" fill="#000">
            <Path
              id="Vector_9"
              d="M177.349 247.974c.095.079.19.151.278.23-.096-.079-.183-.159-.278-.23Z"
            />
            <Path
              id="Vector_10"
              d="M175.832 246.886c.111.072.214.143.317.207a7.134 7.134 0 0 0-.317-.207Z"
            />
            <Path
              id="Vector_11"
              d="M178.063 248.586c.087.079.175.159.254.238-.087-.079-.167-.159-.254-.238Z"
            />
            <Path
              id="Vector_12"
              d="M170.961 244.645a2.766 2.766 0 0 1-.397-.786c.111.326.246.596.397.786Z"
            />
            <Path
              id="Vector_13"
              d="m171.558 245.043-.071-.024c-.04-.008-.064-.032-.104-.048.032.016.064.04.104.048.023 0 .047.016.071.024Z"
            />
            <Path
              id="Vector_14"
              d="M170.969 244.654a.925.925 0 0 0 .239.23c-.088-.063-.159-.143-.239-.23Z"
            />
            <Path
              id="Vector_15"
              d="m178.747 249.245.23.23a3.564 3.564 0 0 0-.23-.23Z"
            />
            <Path
              id="Vector_16"
              d="M176.609 247.402c.103.071.206.151.302.222a8 8 0 0 0-.302-.222Z"
            />
            <Path
              id="Vector_17"
              d="M179.604 250.167a5.522 5.522 0 0 1-.191-.223c.064.072.127.143.191.223Z"
            />
            <Path
              id="Vector_18"
              d="M180.764 251.659s-.055-.079-.087-.119c.032.04.055.079.087.119Z"
            />
            <Path
              id="Vector_19"
              d="M174.536 246.154c-.119-.055-.23-.119-.349-.175.119.056.23.112.349.175Z"
            />
            <Path
              id="Vector_20"
              d="M173.32 245.615c.119.047.231.095.35.143-.119-.048-.231-.104-.35-.143Z"
            />
          </G>
          <Path
            id="hair_2"
            d="M67.489 144.994c-3.63 11.923-10.724 40.075-16.42 48.511-5.243 7.777-21.988 25.745-17.515 47.423 1.66-5.084 2.24-18.937 5.894-22.845-1.287 5.56-5.736 20.089.405 36.278a152.812 152.812 0 0 0 8.762 8.809c5.084-3.288 15.498-9.786 23.25-12.987 7.92-3.273 19.184-2.701 29.185-8.119a1253.253 1253.253 0 0 1-4.003-2.971s11.446-7.586 14.155-18.595c1.676-6.816 7.189-45.041 4.663-50.99-.215.119-7.658.016-14.386-6.697-.159-.023-.246-.039-.246-.039l.151-.064c1.469-.604 13.424-5.695 25.054-15.895 14.306-12.543 20.748-41.044 22.377-49.449-.755.207-1.509.397-2.272.612-29.359 8.182-59.339 27.072-79.054 47.018Zm67.44-19.374c-1.398 4.392-7.109 19.938-19.612 26.706 6.077-8.341 17.388-21.122 19.612-26.706.239-.747.358-1.184.358-1.184-.056.342-.183.747-.358 1.184Z"
            fill={c.hair}
          />
          <Path
            id="Vector_21"
            d="M151.833 303.667c27.898 0 54.024-7.531 76.489-20.654-4.576-7.474-10.724-15.633-18.39-21.543-.087.08-.151.135-.151.135l-27.016-6.481c6.53 13.527 3.607 35.476-1.747 37.954-7.086 3.281-79.388-50.553-83.773-53.818.477.358-17.031 9.048-25.396 10.931-11.438 2.573-19.803 6.331-25.935 10.437 27.357 26.635 64.708 43.047 105.903 43.047l.016-.008Z"
            fill="#000"
          />
        </G>
      </G>
    </Svg>
  );
};
